(ns app.front.view.system-of-units.neighbour-radius-defaults
  (:require [app.domain.workspace.model :as workspace-model]
            [app.front.view.system-of-units.toggle :as sou-toggle]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::default-neighbour-radius
  :<- [::sou-toggle/default-system-of-units]
  :-> workspace-model/default-neighbour-radius)

(rf/reg-sub ::max-neighbour-radius
  :<- [::sou-toggle/default-system-of-units]
  :-> workspace-model/max-neighbour-radius)
